var _a, _b, _c, _d, _e, _f, _g, _h;
export const API_ADDRESS = (_a = process.env.API_ADDRESS) !== null && _a !== void 0 ? _a : '';
export const API_SKIP_AUTH = (_b = process.env.API_SKIP_AUTH) !== null && _b !== void 0 ? _b : false;
export const API_FULL_STYLE_ENDPOINT = (_c = process.env.API_FULL_STYLE_ENDPOINT) !== null && _c !== void 0 ? _c : '';
export const API_CUSTOMIZER_SCENE_ENDPOINT = (_d = process.env.API_CUSTOMIZER_SCENE_ENDPOINT) !== null && _d !== void 0 ? _d : 'customizer-scene-generator/v1';
export const API_CUSTOMIZER_RECIPES_ENDPOINT = (_e = process.env.API_CUSTOMIZER_RECIPES_ENDPOINT) !== null && _e !== void 0 ? _e : 'customizer-recipes/v1';
export const API_LOGOS_FOR_GENERATORS_ENDPOINT = (_f = process.env.API_LOGOS_FOR_GENERATORS_ENDPOINT) !== null && _f !== void 0 ? _f : 'logos-for-generators/v1';
export const API_COLORWAYS_ENDPOINT = (_g = process.env.API_COLORWAYS_ENDPOINT) !== null && _g !== void 0 ? _g : 'data/v1/colorways';
export const API_CUSTOMIZER_COLORWAY_SWITCH_ENDPOINT = (_h = process.env.API_CUSTOMIZER_COLORWAY_SWITCH_ENDPOINT) !== null && _h !== void 0 ? _h : 'customizer-colorway-switch/v1';
export const getApiAddress = () => {
    return API_ADDRESS;
};
export const getApiSkipAuth = () => {
    return API_SKIP_AUTH === 'true';
};
export const getApiFullStyleEndpoint = () => {
    return API_FULL_STYLE_ENDPOINT;
};
export const getApiCustomizerSceneEndpoint = () => {
    return API_CUSTOMIZER_SCENE_ENDPOINT;
};
export const getApiCustomizerRecipesEndpoint = () => {
    return API_CUSTOMIZER_RECIPES_ENDPOINT;
};
export const getApiLogosForGeneratorsEndpoint = () => {
    return API_LOGOS_FOR_GENERATORS_ENDPOINT;
};
export const getApiColorwaysEndpoint = () => {
    return API_COLORWAYS_ENDPOINT;
};
export const getApiCustomizerColorwaySwitchEndpoint = () => {
    return API_CUSTOMIZER_COLORWAY_SWITCH_ENDPOINT;
};
